type ModalTypes =
  | 'close'
  | 'warningLevels'
  | 'warningLevelsCompleted'
  | 'fireDangerRatings'
  | 'fireDangerRatingsCompleted'
  | 'higherRiskPeople';

export const MyEmergencyPlanModalIdentifiers: Record<ModalTypes, string> = {
  close: '#confirm-close',
  warningLevels: '#warning-levels',
  warningLevelsCompleted: '#warning-levels-completed',
  fireDangerRatings: '#fire-danger-ratings',
  fireDangerRatingsCompleted: '#fire-danger-ratings-completed',
  higherRiskPeople: '#higher-risk-people',
};
